/**
 * Menu List with Images Pattern JavaScript
 * Handles category filtering functionality
 */

/**
 * Initialize the menu category filter functionality
 */
export function initMenuCategoryFilter() {
    const filterContainer = document.querySelector('.menu-category-filter');
    const pillsContainer = document.querySelector('.category-pills');
    const menuItems = document.querySelectorAll('.menu-items-list .menu-item');
    
    // Exit if no filter container or menu items found
    if (!filterContainer || !pillsContainer || menuItems.length === 0) {
        return;
    }
    
    // Generate category pills dynamically
    const categories = extractCategoriesFromMenuItems(menuItems);
    
    // Only show filter if there are categories
    if (categories.length === 0) {
        return;
    }
    
    // Create and insert category pills
    createCategoryPills(pillsContainer, categories);
    
    // Show the filter container
    filterContainer.style.display = 'block';
    
    // Add event listeners to pills
    attachPillEventListeners();
}

/**
 * Extract unique categories from menu items
 * @param {NodeList} menuItems - All menu items
 * @returns {Array} Array of unique category objects
 */
function extractCategoriesFromMenuItems(menuItems) {
    const categoryMap = new Map();
    
    menuItems.forEach(function(item) {
        const itemCategories = extractCategoryClasses(item);
        
        if (itemCategories) {
            itemCategories.forEach(function(categorySlug) {
                if (categorySlug.trim() && !categoryMap.has(categorySlug)) {
                    // Convert slug to readable name (capitalize and replace hyphens)
                    const categoryName = categorySlug
                        .split('-')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    
                    categoryMap.set(categorySlug, {
                        slug: categorySlug,
                        name: categoryName
                    });
                }
            });
        }
    });
    
    return Array.from(categoryMap.values());
}

/**
 * Create category pill buttons
 * @param {Element} container - Container to insert pills into
 * @param {Array} categories - Array of category objects
 */
function createCategoryPills(container, categories) {
    // Clear existing content
    container.innerHTML = '';
    
    // Create "All" button
    const allButton = document.createElement('button');
    allButton.className = 'category-pill active';
    allButton.setAttribute('data-category', 'all');
    allButton.textContent = 'All';
    container.appendChild(allButton);
    
    // Create category buttons
    categories.forEach(function(category) {
        const button = document.createElement('button');
        button.className = 'category-pill';
        button.setAttribute('data-category', category.slug);
        button.textContent = category.name;
        container.appendChild(button);
    });
}

/**
 * Attach event listeners to category pills
 */
function attachPillEventListeners() {
    const categoryPills = document.querySelectorAll('.category-pill');
    const menuItems = document.querySelectorAll('.menu-items-list .menu-item');
    
    categoryPills.forEach(function(pill) {
        // Add click event listener
        pill.addEventListener('click', function() {
            const selectedCategory = this.getAttribute('data-category');
            
            // Remove active class from all pills
            categoryPills.forEach(function(p) {
                p.classList.remove('active');
            });
            
            // Add active class to clicked pill
            this.classList.add('active');
            
            // Filter menu items
            filterMenuItems(menuItems, selectedCategory);
        });

        // Add keyboard support for accessibility
        pill.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
}

/**
 * Filter menu items based on selected category
 * @param {NodeList} menuItems - All menu items to filter
 * @param {string} selectedCategory - The category to filter by
 */
function filterMenuItems(menuItems, selectedCategory) {
    menuItems.forEach(function(item) {
        const itemCategories = extractCategoryClasses(item);

        if (selectedCategory === 'all') {
            // Show all items
            showMenuItem(item);
        } else if (itemCategories.includes(selectedCategory)) {
            // Show items that match the selected category
            showMenuItem(item);
        } else {
            // Hide items that don't match
            hideMenuItem(item);
        }
    });
}

/**
 * Show a menu item with smooth animation
 * @param {Element} item - The menu item to show
 */
function showMenuItem(item) {
    item.style.display = 'flex';
    item.classList.remove('hidden');
    
    // Force reflow for smooth animation
    void item.offsetHeight;
}

/**
 * Hide a menu item with smooth animation
 * @param {Element} item - The menu item to hide
 */
function hideMenuItem(item) {
    item.classList.add('hidden');
    
    // Hide completely after animation completes
    setTimeout(function() {
        if (item.classList.contains('hidden')) {
            item.style.display = 'none';
        }
    }, 300); // Match CSS transition duration
}

function extractCategoryClasses(cat) {
    const classList = cat.className.split(' ');
    const categoryClasses = classList.filter(cls => cls.startsWith('category-'));
    const categories = categoryClasses.map(cls => cls.replace('category-', ''));

    return categories;
}